// Öffentliche Seiten (Startseite, Betreiber-Seite). Der Inhalt kommt fertig vom Server — hier nur Zahlen nachladen
// und die Knöpfe an den Besucher anpassen. Bewusst ohne Designsystem-JS: kein Ripple, kein Router,
// damit die Seite mit wenigen KB Skript auskommt. Texte über window.tr aus /js/i18n.js.
// Stile kommen über den eigenen Einstieg public-css (siehe public-entry.css).
// Ziele kommen vom Server: Startziel nach Rolle aus /api/me (home), Anmeldung aus dem Anmelde-Link der Hülle.
// Bewusst ohne Import (Budget dieser Seite).

const tr = (k, v) => (typeof window !== 'undefined' && window.tr ? window.tr(k, v) : k);
const loc = () => (typeof window !== 'undefined' && window.vcLocale) || (typeof document !== 'undefined' && document.documentElement.lang) || 'de';
const getJson = (url) => fetch(url, { credentials: 'same-origin' }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
const num = (n) => Number(n).toLocaleString(loc());

/** Zahl nur übernehmen, wenn sie wirklich da ist — sonst bleibt der serverseitige Wert stehen. */
export function setStat(el, value) {
  if (!el || value == null || value === '' || !Number.isFinite(Number(value)) || Number(value) <= 0) return false;
  el.textContent = num(value);
  return true;
}

/** Wer ist hier? 'user' (angemeldet), 'returning' (Konto im Browser gemerkt), sonst 'new'. */
export function visitorKind(me, remembered) {
  if (me && me.id) return 'user';
  return remembered ? 'returning' : 'new';
}

function adaptCtas(kind, me) {
  const ctas = document.querySelectorAll('[data-pub-cta]');
  if (kind === 'user') {
    for (const a of ctas) { if (me.home) a.href = me.home; a.textContent = tr('landing_js.cta_to_app'); }
    for (const a of document.querySelectorAll('[data-pub-login]')) a.hidden = true;
    const hello = document.querySelector('[data-pub-hello]');
    if (hello) { hello.querySelector('[data-pub-hello-text]').textContent = tr('landing_js.logged_in_hint', { name: me.name || tr('landing_js.default_name') }); hello.hidden = false; }
  } else if (kind === 'returning') {
    const login = document.querySelector('[data-pub-login]');
    for (const a of ctas) { if (login) a.href = login.getAttribute('href'); a.textContent = tr('landing_js.cta_login'); }
  }
}

/** Stichtag anwenden: offen → „noch N Tage“ einblenden; vorbei → beendete Fassung zeigen. */
export function applyFounder(root, d) {
  if (!d || typeof d.open !== 'boolean') return;
  const all = (q) => [...root.querySelectorAll(q)];
  for (const el of all('[data-founder-open]')) el.hidden = !d.open;
  for (const el of all('[data-founder-closed]')) el.hidden = d.open;
  for (const el of all('[data-founder-days]')) {
    const n = Number(d.days_left);
    el.hidden = !d.open || !(n > 0);
    const s = el.querySelector('#pricing-days'); if (s && n > 0) s.textContent = num(n);
  }
}

function init() {
  const $ = (q) => document.querySelector(q);
  // Je Seite nur abfragen, was sie anzeigt.
  if ($('[data-stat]')) getJson('/api/landing-stats').then((d) => {
    if (!d) return;
    for (const k of ['spots', 'countries', 'reviews']) setStat($(`[data-stat="${k}"]`), d[k]);
  });
  // Pfadfinder-Programm: Stichtag statt Platzzahl. Ohne Antwort bleibt der offene Text stehen (er nennt das Datum).
  if ($('[data-founder-open]')) getJson('/api/public/founder-status').then((d) => applyFounder(document, d));
  // Ratgeber: Checkliste drucken
  document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('[data-print]')) print(); });
  if (!$('[data-pub-cta]')) return;
  let remembered = false;
  try { remembered = localStorage.getItem('vc-registered') === '1'; } catch {}
  if (remembered) adaptCtas('returning');
  getJson('/api/me/optional').then((me) => {
    const kind = visitorKind(me, remembered);
    if (kind === 'user') { try { localStorage.setItem('vc-registered', '1'); } catch {} }
    adaptCtas(kind, me);
  });
}

/** Felder, die das Kontaktformular im Browser prüft (gleiche Regeln wie lib/contact.js). */
export function contactErrors(f) {
  const e = [];
  if (String(f.name || '').trim().length < 2) e.push('name');
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(f.email || '').trim())) e.push('email');
  const m = String(f.message || '').trim().length;
  if (m < 10 || m > 4000) e.push('message');
  return e;
}

// Kontaktformular der Betreiber-Seite: ohne Skript ein normaler Formular-POST (Server leitet zurück),
// mit Skript Prüfung am Feld, Senden per fetch und Dank in der Karte.
function initContact() {
  const form = document.querySelector('[data-contact-form]');
  if (!form) return;
  const status = form.querySelector('[data-contact-status]');
  const done = form.querySelector('[data-contact-done]');
  const btn = form.querySelector('button[type="submit"]');
  const label = btn.querySelector('[data-label]');
  const idle = label.textContent;
  const msg = (k) => (form.querySelector(`template[data-msg="${k}"]`) || {}).innerHTML || '';
  const showDone = () => { form.classList.add('is-done'); done.hidden = false; done.focus(); };
  const mark = (errs) => {
    for (const el of form.querySelectorAll('[name="name"], [name="email"], [name="message"]')) {
      const bad = errs.includes(el.name);
      el.setAttribute('aria-invalid', bad ? 'true' : 'false');
      const help = form.querySelector(`[data-err="${el.name}"]`);
      if (help) help.hidden = !bad;
    }
  };
  // Knöpfe „Website-Check anfragen“ usw. wählen das Thema vor.
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[data-interest]');
    if (a) form.elements.interest.value = a.dataset.interest;
  });
  const q = new URLSearchParams(location.search).get('kontakt');
  if (q === 'ok') showDone();
  else if (q === 'fehler') { status.textContent = msg('error'); status.hidden = false; }
  form.addEventListener('input', (e) => { if (e.target.getAttribute('aria-invalid') === 'true') mark(contactErrors(Object.fromEntries(new FormData(form))).filter((n) => n === e.target.name)); });
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(form));
    const errs = contactErrors(data);
    mark(errs);
    if (errs.length) { form.querySelector(`[name="${errs[0]}"]`).focus(); return; }
    status.hidden = true; btn.disabled = true; label.textContent = btn.dataset.sending;
    try {
      const r = await fetch(form.action, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data), credentials: 'same-origin' });
      if (r.ok) { showDone(); return; }
      const body = await r.json().catch(() => ({}));
      if (r.status === 400 && Array.isArray(body.fields)) { mark(body.fields); form.querySelector(`[name="${body.fields[0]}"]`)?.focus(); }
      else { status.textContent = msg(r.status === 429 ? 'rate' : 'error'); status.hidden = false; }
    } catch { status.textContent = msg('error'); status.hidden = false; }
    btn.disabled = false; label.textContent = idle;
  });
}
if (typeof document !== 'undefined') initContact();

// Service Worker nur, wenn die Seite die installierbare App ist (Manifest verlinkt = nach dem Umschalten).
function registerSw() {
  if (!document.querySelector('link[rel="manifest"]') || !('serviceWorker' in navigator)) return;
  addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}), { once: true });
}

if (typeof document !== 'undefined') { init(); registerSw(); }
